<app-organization-receives-chart
  [rows]="sortedRows"
  [categories]="categories"
  (quickViewRequested)="openQuickView($event)"
></app-organization-receives-chart>

<aside
  class="alert alert-light border mt-4 mb-0"
  aria-labelledby="who-pays-heading"
>
  <h2 id="who-pays-heading" class="h5 fw-bold mb-2">
    Keeping 100% does not always mean there are no fees.
  </h2>
  <p class="mb-0">
    Some platforms deduct costs from the organization. Others pass costs to
    supporters or use optional tips. The cards below show who pays under the
    selected configuration.
  </p>
</aside>

<div class="mt-4 mt-md-5">
  <section
    *ngFor="let category of categories; trackBy: trackCategory"
    class="py-0 mb-4 mb-md-5"
    [attr.aria-labelledby]="'platform-category-' + category.id"
  >
    <h2 [id]="'platform-category-' + category.id" class="h3 fw-bold mb-3">
      {{ category.label }}
    </h2>

    <div class="row g-3 g-lg-4">
      <div
        *ngFor="let row of rowsForCategory(category); trackBy: trackRow"
        class="col-12 col-md-6 col-lg-4"
      >
        <app-platform-overview-card
          [row]="row"
          (quickViewRequested)="openQuickView($event)"
          (detailLinkClicked)="detailLinkClicked.emit($event)"
        ></app-platform-overview-card>
      </div>
    </div>
  </section>
</div>

<app-platform-quick-view
  [row]="activeRow"
  (optionChange)="optionChange.emit($event)"
  (quickViewClosed)="quickViewClosed.emit($event)"
  (fullPageClicked)="quickViewFullPageClicked.emit($event)"
></app-platform-quick-view>
